module.exports = __webpack_public_path__ + "static/media/table.ffc62d09.png";